module.exports = __webpack_public_path__ + "static/media/AboutContent-3.69e56a40.png";